import { AnchorHTMLAttributes, MouseEventHandler, forwardRef } from "react";
import { tv } from "tailwind-variants";
import { Button as ButtonRAC } from "react-aria-components";
import { useLinkClickHandler } from "../../navigation";

interface LinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "onClick"> {
  className?: string;
  href?: string;
  variant?: "link-1" | "link-2" | "link-3" | "link-4" | "link-5";
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  onPress?: () => void;
}

const styles = tv({
  base: "outline-hidden hover:underline transition font-medium tracking-normal text-black",
  variants: {
    variant: {
      "link-1": "text-base leading-12",
      "link-2": "text-md leading-11",
      "link-3": "text-sm leading-10",
      "link-4": "text-xs leading-9",
      "link-5": "text-2xs leading-8",
    },
  },
  defaultVariants: {
    variant: "link-1",
  },
});

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  (
    { variant = "link-1", className, href, onClick, onPress, ...props },
    ref,
  ) => {
    const handleClick = useLinkClickHandler(href, onClick);
    return href ? (
      <a
        {...props}
        href={href}
        onClick={handleClick}
        ref={ref}
        className={styles({ variant, className })}
      />
    ) : (
      <ButtonRAC onPress={onPress} className={styles({ variant, className })}>
        {props.children}
      </ButtonRAC>
    );
  },
);

Link.displayName = "Link";

export default Link;
